import { Form, Input, Modal, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import useAppMessage from '@/hooks/useAppMessage';
import { redeemBenefit } from '@/services/admin/benefit';

type RedeemBenefitModalProps = {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
};

type RedeemFormValues = {
  code: string;
};

const RedeemBenefitModal: React.FC<RedeemBenefitModalProps> = ({
  open,
  onClose,
  onSuccess,
}) => {
  const appMessage = useAppMessage();
  const [form] = Form.useForm<RedeemFormValues>();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!open) {
      return;
    }
    form.resetFields();
  }, [form, open]);

  const handleOk = async () => {
    if (submitting) {
      return;
    }
    try {
      const values = await form.validateFields();
      setSubmitting(true);
      const result = await redeemBenefit({ code: values.code.trim() });
      const amountText = result?.balanceTopUpAmountYuan?.trim();
      appMessage.success(
        amountText ? `兑换成功，已充值 ${amountText} 元` : '兑换成功',
      );
      onSuccess?.();
      onClose();
    } catch (error) {
      if (error && typeof error === 'object' && 'errorFields' in error) {
        return;
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title="兑换权益"
      open={open}
      onCancel={onClose}
      onOk={handleOk}
      okText="兑换"
      cancelText="取消"
      confirmLoading={submitting}
      destroyOnHidden
      width={520}
    >
      <Form form={form} style={{ padding: '24px 8px' }}>
        <Form.Item
          label="兑换码"
          name="code"
          rules={[
            { required: true, message: '请输入您的权益兑换码' },
            {
              validator: (_, value) => {
                if (value && !String(value).trim()) {
                  return Promise.reject(new Error('请输入您的权益兑换码'));
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input placeholder="请输入您的权益兑换码" allowClear maxLength={64} />
        </Form.Item>
      </Form>
      <Typography.Paragraph
        type="secondary"
        style={{ marginBottom: 0, fontSize: 13 }}
      >
        兑换后，您可以在代计费管理-账户流水界面中查看兑换结果。
      </Typography.Paragraph>
    </Modal>
  );
};

export default RedeemBenefitModal;
